var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading && !_vm.hideLoader)?_c('content-loader',{attrs:{"transparent":""}}):_vm._t("default",null,{"schema":_vm.schema,"uiSchema":_vm.uiSchema,"formData":_vm.formData,"loading":_vm.loading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }